import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <main className="max-w-md mx-auto px-6 py-24 text-center">
        <div className="fleuron mb-6">❦</div>
        <p className="font-display italic text-2xl text-ink-iron">Reading the ledger…</p>
      </main>
    );
  }
  if (!user) return <Navigate to="/sign-in" state={{ from: location.pathname }} replace />;
  return children;
}
